import Notic from '../Notic';
window.Notic = Notic;
export default Notic;
